import { Alert } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { useFreezeDate } from '../hooks/useFreezeDate';

export function FreezeDateAlert() {
  const { t } = useTranslation();
  const { isAfterFreezeDate, formattedFreezeDate } = useFreezeDate();

  if (formattedFreezeDate != null) {
    const infoIcon = <IconInfoCircle />;

    const alertMessage = t('freezeDate.alert.message');
    const errorMessage = t('freezeDate.alert.errorMessage');

    if (isAfterFreezeDate) {
      return (
        <Alert
          mb="10px"
          variant="dark"
          color="red"
          icon={infoIcon}
        >
          {errorMessage}
        </Alert>
      );
    } else {
      return (
        <Alert
          mb="10px"
          variant="dark"
          color="blue"
          icon={infoIcon}
        >
          {alertMessage}
          {formattedFreezeDate}
        </Alert>
      );
    }
  }

  return null;
}
